{
  "title_providers": "NCPeH - Παροχείς",
  "title_beneficiaries": "NCPeH - Δικαιούχοι",
  "common": {
    "every": "Κάθε",
    "hour": "ώρα",
    "hour_multi": "ώρες",
    "day": "μέρα",
    "day_multi": "μέρες",
    "week": "εβδομάδα",
    "week_multi": "εβδομάδες",
    "month": "μήνας",
    "month_multi": "μήνες",
    "year": "χρόνος",
    "year_multi": "χρόνια",
    "profile": {
      "user_info": "Πληροφορίες Χρήστη",
      "name": "Όνομα",
      "surname": "Επώνυμο",
      "medical_registry_id": "ΑΜ",
      "professional_title": "Επαγγελματικός Τίτλος",
      "phone": "Τηλέφωνο",
      "email": "Ηλεκτρονικό Ταχυδρομείο",
      "address": "Διεύθυνση",
      "specialty_1": "Ειδικότητα 1",
      "specialty_2": "Ειδικότητα 2",
      "specialty_3": "Ειδικότητα 3"
    }
  },
  "login": {
    "login": "Είσοδος",
    "exit": "Έξοδος",
    "text_providers": "Οι επαγγελματίες υγείας με την είσοδο τους στην πλατφόρμα έχουν τη δυνατότητα παροχής υπηρεσιών που αφορούν το Συνοπτικό Ιστορικό Υγείας του Ασθενούς, την Ηλεκτρονική Συνταγογράφηση και Εκτέλεση Συνταγής.",
    "text_beneficiaries": "Με την είσοδό τους στην πλατφόρμα, οι πολίτες έχουν τη δυνατότητα προβολής του Συνοπτικού Ιστορικού Υγείας τους, καθώς και των Ηλεκτρονικών Συνταγών που τους έχουν εκδοθεί, χωρίς δυνατότητα επεξεργασίας.",
    "welcome": "Καλωσορίσατε στην πύλη των Ηλεκτρονικών Διασυνοριακών Υπηρεσιών Υγείας"
  },
  "home": {
    "national": "Εθνικός Πολίτης",
    "european": "Ευρωπαίος πολίτης",
    "profile": "Το προφίλ μου",
    "national_text": "Δημιουργία ή επικαιροποίηση Συνοπτικού Ιστορικού Υγείας και έκδοση Διασυνοριακής Ηλεκτρονικής Συνταγής Κύπριου πολίτη.",
    "european_text": "Ανάκτηση Συνοπτικού Ιστορικού Υγείας ή εκτέλεση Διασυνοριακής Ηλεκτρονικής Συνταγής Ευρωπαίου πολίτη που έρχεται από άλλη χώρα της Ευρωπαϊκής Ένωσης.",
    "profile_text": "Το προφίλ μου επεξηγηματικό σχόλιο",
    "enter": "Είσοδος"
  },
  "select": {
    "labels": {
      "documentType": "Τύπος Εγγράφου Ταυτοποίησης",
      "information_allergies": "Πληροφορίες για αλλεργίες",
      "information_procedures": "Πληροφορίες για χειρουργικές επεμβάσεις",
      "information_problems": "Πληροφορίες για προβλήματα/διαγνώσεις",
      "information_devices": "Πληροφορίες για συσκευές/εμφυτεύματα",
      "information_medication": "Πληροφορίες για φαρμακευτική αγωγή"
    },
    "arc": "Πιστοποιητικό Εγγραφής Αλλοδαπού",
    "cypriot": "Κυπριακή Ταυτότητα",
    "10itemsPerPage": "10 αντικείμενα ανά σελίδα",
    "25itemsPerPage": "25 αντικείμενα ανά σελίδα",
    "50itemsPerPage": "50 αντικείμενα ανά σελίδα",
    "100itemsPerPage": "100 αντικείμενα ανά σελίδα",
    "has_allergies": "Έχει αλλεργίες",
    "no_info_allergies": "Δεν υπάρχουν πληροφορίες για αλλεργίες",
    "no_known_allergies": "Δεν υπάρχουν γνωστές αλλεργίες",
    "has_procedures": "Έχει χειρουργικές επεμβάσεις",
    "no_info_procedures": "Δεν υπάρχουν πληροφορίες για χειρουργικές επεμβάσεις",
    "no_known_procedures": "Δεν υπάρχουν γνωστές χειρουργικές επεμβάσεις",
    "has_problems": "Έχει προβλήματα/διαγνώσεις",
    "no_info_problems": "Δεν υπάρχουν πληροφορίες για προβλήματα/διαγνώσεις",
    "no_known_problems": "Δεν υπάρχουν γνωστά προβλήματα/διαγνώσεις",
    "has_devices": "Έχει συσκευές/εμφυτεύματα",
    "no_info_devices": "Δεν υπάρχουν πληροφορίες για συσκευές/εμφυτεύματα",
    "no_known_devices": "Δεν υπάρχουν γνωστές συσκευές/εμφυτεύματα",
    "has_medication": "Έχει καταχωριμένη φαρμακευτική αγωγή",
    "no_info_medication": "Δεν υπάρχουν πληροφορίες για φαρμακευτική αγωγή",
    "no_known_medication": "Δεν υπάρχει φαρμακευτική αγωγή"
  },
  "nav": {
    "patient_data": "Δεδομένα Ασθενή",
    "clinical_data": "Κλινικά Δεδομένα Ασθενή",
    "summary_data": "Δεδομένα Συνοπτικού Ιστορικού Υγείας Ασθενή",
    "allergies": "Αλλεργίες",
    "vaccinations": "Εμβολιασμοί",
    "history_past_illness": "Ιστορικό Παρελθοντικών Ασθενειών"
  },
  "input": {
    "labels": {
      "page": "Σελίδα",
      "idNumber": "Αριθμός Εγγράφου",
      "address": "Διεύθυνση",
      "number": "Αριθμός",
      "post_code": "Ταχυδρομικός Κώδικας",
      "city": "Πόλη",
      "country": "Χώρα",
      "email": "Ηλεκτρονικό Ταχυδρομείο",
      "telephone": "Αριθμός Κινητού Τηλεφώνου",
      "otp": "Κωδικός μιας Χρήσης",
      "given_name": "Όνομα",
      "family_name": "Επώνυμο",
      "telephone_number": "Τηλέφωνο",
      "insurance_name": "Ασφαλιστική Επωνυμία",
      "insurance_number": "Αριθμός Ασφάλειας",
      "systolic_bp": "Συστολική Αρτηριακή Πίεση",
      "diastolic_bp": "Διαστολική Αρτηριακή Πίεση",
      "quantity": "Ποσότητα",
      "frequency_of_use": "Συχνότητα λήψης",
      "treatment_duration": "Διάρκεια θεραπείας",
      "numberOfPackages": "Αριθμός Συσκευασιών",
      "select_file": "Επιλέξτε Αρχείο (PDF)",
      "select_image": "Επιλέξτε Εικόνα",
      "author_full_name": "Ονοματεπώνυμο Συντάκτη",
      "old_email": "Τρέχων Ηλεκτρονικό Ταχυδρομίο",
      "new_email": "Νέο Ηλεκτρονικό Ταχυδρομίο",
      "old_phone": "Τρέχων Αριθμός Κινητού Τηλφώνου",
      "new_phone": "Νέος Αριθμός Κινητού Τηλεφώνου"
    },
    "placeholders": {
      "default": "Πληκτρολογήστε εδώ...",
      "brand_name": "Αναζήτηση με εμπορική ονομασία...",
      "active_substance": "Αναζήτηση με ενεργό συστατικό...",
      "atc_code": "Αναζήτηση με κωδικό ATC...",
      "author_full_name": "Ονοματεπώνυμο Συντάκτη"
    }
  },
  "textarea": {
    "labels": {
      "resolution_circumstances": "Συνθήκες Επίλυσης",
      "treatment_recommendations": "Σύσταση Θεραπείας",
      "autonomy_invalidity": "Περιγραφή",
      "instructions_patient": "Οδηγίες προς τον ασθενή",
      "instructions_pharmacist": "Οδηγίες προς τον φαρμακοποιό",
      "reason_disabled": "Λόγος Απενεργοποίησης Εγγραφής"
    },
    "placeholders": {
      "default": "Πληκτρολογήστε εδώ..."
    }
  },
  "dropdown": {
    "labels": {
      "allergy_description": "Περιγραφή Αλλεργίας",
      "drug_allergy_description": "Περιγραφή Αλλεργίας/Δυσανεξίας σε Φάρμακα",
      "agent_description": "Περιγραφή Aλλεργιογόνου",
      "allergen_description": "Περιγραφή Aλλεργιογόνου",
      "reaction_description": "Περιγραφή Αντίδρασης",
      "severity_description": "Περιγραφή Σοβαρότητας",
      "country_description": "Χώρα",
      "vaccination_description": "Αναζήτηση Εμβολίου",
      "illness_description": "Περιγραφή Προβλημάτων/Διάγνωσης",
      "procedure_description": "Περιγραφή Χειρουργικής Επέμβασης",
      "problem_description": "Περιγραφή Προβλήματος/Διάγνωσης",
      "device_description": "Περιγραφή Συσκευής/Εμφυτεύματος",
      "social_history_description": "Περιγραφή Κοινωνικού Ιστορικού",
      "blood_type": "Ομάδα Αίματος",
      "pregnancy_description": "Περιγραφή Εγκυμοσύνης",
      "medicines_search": "Αναζήτηση Φαρμακευτικού Προϊόντος",
      "package_description": "Περιγραφή Συσκευασίας",
      "units_intake_description": "Μονάδες ανά Δόση",
      "time_unit_description": "Μονάδες Χρόνου",
      "specialty": "Ειδικότητα",
      "reason_of_hospitalization": "Λόγος Νοσηλείας",
      "hospital": "Νοσοκομείο",
      "laboratory": "Εργαστήριο",
      "medical_center": "Ιατρικό Κέντρο",
      "brand_name": "Εμπορική Ονομασία",
      "pharmacy": "Επιλέξτε Φαρμακείο"
    },
    "placeholders": {
      "default": "Πατήστε εδώ...",
      "allergy_description": "Εισάγετε Περιγραφή Αλλεργίας",
      "drug_allergy_description": "Εισάγετε Περιγραφή Αλλεργίας/Δυσανεξίας",
      "agent_description": "Εισάγετε Περιγραφή Aλλεργιογόνου",
      "allergen_description": "Εισάγετε Περιγραφή Aλλεργιογόνου",
      "reaction_description": "Εισάγετε Περιγραφή Αντίδρασης",
      "severity_description": "Εισάγετε Περιγραφή Σοβαρότητας",
      "country_description": "Εισάγετε Χώρα",
      "vaccination_description": "Εισάγετε Περιγραφή Εμβολιασμού",
      "illness_description": "Εισάγετε Περιγραφή Προβλήματος/Διάγνωσης",
      "procedure_description": "Εισάγετε Περιγραφή Χειρουργικής Επέμβασης",
      "problem_description": "Εισάγετε Περιγραφή Προβλήματος/Διάγνωσης",
      "device_description": "Εισάγετε Περιγραφή Συσκευής/Εμφυτεύματος",
      "social_history_description": "Εισάγετε Περιγραφή Κοινωνικού Ιστορικού",
      "blood_type": "Εισάγετε Ομάδα Αίματος",
      "pregnancy_description": "Εισάγετε Περιγραφή Εγκυμοσύνης",
      "medicines_search": "Εισάγετε Φαρμακευτικό Προϊόν",
      "package_description": "Εισάγετε Περιγραφή Συσκευασίας",
      "units_intake_description": "Εισάγετε Μονάδες ανά Δόση",
      "time_unit_description": "Εισάγετε Χρονική Μονάδα Λήψης",
      "specialty": "Ειδικότητα",
      "reason_of_hospitalization": "Λόγος Νοσηλείας",
      "select_hospital": "Επιλέξτε Νοσοκομείο",
      "select_laboratory": "Επιλέξτε Εργαστήριο",
      "select_medical_center": "Επιλέξτε Ιατρικό Κέντρο"
    },
    "noData": "Δεν υπάρχουν δεδομένα. Παρακαλώ κάντε αναζήτηση."
  },
  "table": {
    "itemsPerPage": "αντικείμενα ανά σελίδα",
    "page": "Σελίδα",
    "of": "από τις",
    "actions": "Ενέργειες",
    "headers": {
      "active": "Ενεργός",
      "inactive": "Ανενεργός",
      "successful": "Επιτυχής",
      "pending": "Αναμονή",
      "activeOne": "Ενεργό",
      "revoked": "Ανακλήθηκε",
      "expired": "Ληγμένο"
    }
  },
  "tables": {
    "Demographics": {
      "title": "Δημογραφικά Στοιχεία Ασθενούς",
      "headers": {
        "nationalId": "Ταυτότητα",
        "phone": "Αριθμός Τηλεφώνου",
        "email": "Ηλεκτρονικό Ταχυδρομείο",
        "address": "Ταχυδρομική Διεύθυνση",
        "country": "Χώρα"
      }
    },
    "Contacts": {
      "title": "Πρόσωπα Επικοινωνίας",
      "headers": {
        "given_name": "Όνομα",
        "family_name_surname": "Επώνυμο",
        "address": "Ταχυδρομική Διεύθυνση",
        "country": "Χώρα",
        "telephone_no": "Αριθμός Τηλεφώνου",
        "email": "Ηλεκτρονικό Ταχυδρομείο",
        "status": "Κατάσταση"
      }
    },
    "Insurances": {
      "title": "Ασφάλιση Υγείας Ασθενούς",
      "headers": {
        "insurance_name": "Ασφαλιστική Επωνυμία",
        "insurance_number": "Αριθμός Ασφάλειας",
        "status": "Κατάσταση"
      }
    },
    "Allergies": {
      "title": "Αλλεργίες",
      "headers": {
        "allergy_onset_date": "Ημερομηνία Έναρξης",
        "allergy_desc": "Περιγραφή Αλλεργίας/Δυσανεξίας",
        "reaction_desc": "Περιγραφή Αντίδρασης",
        "agent_desc": "Περιγραφή Aλλεργιογόνου",
        "sev_desc": "Σοβαρότητα",
        "status": "Κατάσταση"
      }
    },
    "Vaccinations": {
      "title": "Εμβολιασμοί",
      "headers": {
        "vaccination_date": "Ημερομηνία Εμβολιασμού",
        "brand_name": "Εμπορική Ονομασία - Δραστική Ουσία (ATC)",
        "description": "Εμβολιασμοί",
        "status": "Κατάσταση"
      }
    },
    "PastIllness": {
      "title": "Ιστορικό Παρελθοντικών Ασθενειών",
      "headers": {
        "onset_date": "Ημερομηνία Έναρξης",
        "end_date": "Ημερομηνία Λήξης",
        "code": "ICD-10",
        "description": "Περιγραφή Ασθένειας",
        "resolution_circumstances": "Συνθήκες Επίλυσης",
        "status": "Κατάσταση"
      }
    },
    "SurgicalProcedures": {
      "title": "Χειρουργικές Επεμβάσεις",
      "headers": {
        "procedure_date": "Ημερομηνία Διαδικασίας",
        "description": "Περιγραφή",
        "status": "Κατάσταση"
      }
    },
    "ProblemsDiagnoses": {
      "title": "Τρέχοντα Προβλήματα/Διαγνώσεις",
      "headers": {
        "onset_date": "Ημερομηνία Έναρξης",
        "code": "ICD-10",
        "description": "Περιγραφή Προβλήματος/Διάγνωσης",
        "status": "Κατάσταση"
      }
    },
    "DevicesImplants": {
      "title": "Ιατρικές Συσκευές και Εμφυτεύματα",
      "headers": {
        "implant_date": "Ημερομηνία Διαδικασίας Εμφύτευσης",
        "description": "Περιγραφή Συσκευής/Εμφυτεύματος",
        "status": "Κατάσταση"
      }
    },
    "TreatmentRecommendations": {
      "title": "Συστήνουσα θεραπεία",
      "headers": {
        "description": "Περιγραφή Συστάσεων",
        "status": "Κατάσταση"
      }
    },
    "AutonomyInvalidity": {
      "title": "Αυτονομία/Αναπηρία",
      "headers": {
        "description": "Περιγραφή",
        "status": "Κατάσταση"
      }
    },
    "Medication": {
      "title": "Συνοπτικό Φαρμακευτικό Ιστορικό",
      "headers": {
        "date_of_onset": "Ημερομηνία Έναρξης",
        "med_atc_label": "Εμπορική Ονομασία - Δραστική Ουσία (ATC)",
        "strength": "Δύναμη",
        "pharmaceutical_dose_form": "Μορφή Δόσης",
        "intake": "Μονάδες ανά Λήψη",
        "frequency": "Συχνότητα Λήψεων",
        "duration": "Διάρκεια",
        "status": "Κατάσταση"
      }
    },
    "SocialHistory": {
      "title": "Κοινωνικό Ιστορικό",
      "headers": {
        "start_date": "Έτος έναρξης",
        "end_date": "Έτος Λήξης",
        "description": "Περιγραφή Κοινωνικού Ιστορικού",
        "status": "Κατάσταση"
      }
    },
    "PhysicalFindings": {
      "title": "Φυσικά Ευρήματα",
      "headers": {
        "date": "Ημερομηνία Μέτρησης Αρτηριακής Πίεσης",
        "blood_pressure": "Αρτηριακή Πίεση (Συστολική/Διαστολική [mmHg])",
        "status": "Κατάσταση"
      }
    },
    "DiagnosticTests": {
      "title": "Διαγνωστικές Εξετάσεις",
      "headers": {
        "dt": "Ημερομηνία Διαγνωστικής Εξετάσης",
        "description": "Αποτέλεσμα ομάδας αίματος",
        "status": "Κατάσταση"
      }
    },
    "Pregnancies": {
      "title": "Ιστορικό Εγκυμοσύνης",
      "headers": {
        "expected_date_of_delivery": "Αναμενόμενη Ημερομηνία Τοκετού",
        "description": "Περιγραφή",
        "status": "Κατάσταση"
      }
    },
    "Versions": {
      "title": "Εκδόσεις Συνοπτικού Ιστορικού Υγείας Ασθενή",
      "headers": {
        "dt": "Ημερομηνία Δημιουργίας",
        "author": "Δημιουργός",
        "specialty": "Ειδικότητα",
        "nature_description": "Φύση",
        "custodian_name": "Υπεύθυνος"
      }
    },
    "ePrescriptions": {
      "title": "Ηλεκτρονικές Συνταγές (Μόνο για Ηλεκτρονικές Διασυνοριακές Υπηρεσίες Υγείας)",
      "headers": {
        "prescription_id": "Αριθμός Συνταγής",
        "date_of_issue": "Ημερομηνία Έκδοσης",
        "end_date": "Ημερομηνία Λήξης",
        "description": "(Κωδικός ATC) Περιγραφή",
        "status": "Κατάσταση"
      },
      "ePrescriptionDetails": {
        "author": "Συντάκτης",
        "description": "Περιγραφή",
        "brandName": "Εμπορική Ονομασία",
        "strength": "Περιεκτικότητα",
        "pharmaceuticalDoseForm": "Φαρμακοτεχνική Μορφή",
        "packaging": "Συσκευασία",
        "atcCode": "Κωδικός ATC",
        "activeSubstance": "Δραστική Ουσία",
        "substitutionAllowed": "Επιτρέπεται Υποκατάστατο Εμπορικής Ονομασίας",
        "treatment": "Θεραπεία",
        "quantity": "Ποσότητα",
        "frequency": "Συχνότητα Λήψης",
        "route": "Οδός Χορήγησης",
        "advices": "Οδηγίες προς τον φαρμακοποιό",
        "duration": "Διάρκεια θεραπείας",
        "onsetDate": "Ημερομηνία Έναρξης",
        "expiryDate": "Ημερομηνία Λήξης",
        "instructions": "Οδηγίες προς τον ασθενή",
        "dispensationInformation": "Πληροφορίες Εκτέλεσης Συνταγής",
        "numberOfPackages": "Αριθμός Συσκευασιών",
        "routeOfAdministration": "Οδός Χορήγησης",
        "substitution": "Υποκατάσταση",
        "dispensationDate": "Ημερομηνία Εκτέλεσης",
        "countryOfDispensation": "Χώρα Εκτέλεσης",
        "pharmacistName": "Όνομα Φαρμακοποιού",
        "pharmacistTelephone": "Τηλέφωνο Φαρμακοποιού",
        "organization": "Οργανισμός"
      },
      "addForm": {
        "searchOfMedicinal": "Αναζήτηση Φαρμακευτικού Προϊόντος",
        "brandName": "Εμπορική Ονομασία",
        "activeSubstance": "Δραστική Ουσία",
        "atcCode": "Κωδικός ATC",
        "search": "Αναζήτηση",
        "description": "Περιγραφή",
        "productName": "Όνομα Προϊόντος",
        "strength": "Περιεκτικότητα",
        "pharmaceuticalDoseForm": "Φαρμακοτεχνική Μορφή",
        "substitutionAllowed": "Επιτρέπεται Υποκατάσταση Εμπορικής Ονομασίας",
        "yes": "Ναι",
        "no": "Όχι",
        "required": "Παρακαλώ συμπληρώστε το πεδίο",
        "packaging": "Συσκευασία",
        "packageDescription": "Περιγραφή Συσκευασίας",
        "numberOfPackages": "Αριθμός Συσκευασιών",
        "dosage": "Δοσολογία",
        "quantity": "Ποσότητα",
        "unitsPerIntake": "Μονάδες ανά Λήψη",
        "frequency": "Συχνότητα Λήψης",
        "frequencyUnit": "Μονάδα Συχνότητας",
        "routeOfAdministration": "Οδός Χορήγησης",
        "duration": "Διάρκεια Θεραπείας",
        "durationUnit": "Μονάδα Διάρκειας",
        "onsetDate": "Ημερομηνία Έναρξης",
        "instructionsToPatient": "Οδηγίες προς τον ασθενή",
        "advicesToDispenser": "Οδηγίες προς τον φαρμακοποιό"
      }
    },
    "HospitalReports": {
      "title": "Αναφορά Εξιτηρίων Νοσοκομείων",
      "headers": {
        "onset_date": "Ημερομηνία Έναρξης",
        "hcp_name": "Όνομα Ιατρού",
        "hcp_surname": "Επώνυμο Ιατρού",
        "organization_name": "Όνομα Οργανισμού",
        "preview": "Προεπισκόπηση",
        "status": "Κατάσταση"
      }
    },
    "LabReports": {
      "title": "Αναφορά Εργαστηριακών Αποτελεσμάτων",
      "headers": {
        "onset_date": "Ημερομηνία Έναρξης",
        "hcp_name": "Όνομα Ιατρού",
        "hcp_surname": "Επώνυμο Ιατρού",
        "organization_name": "Όνομα Οργανισμού",
        "preview": "Προεπισκόπηση",
        "status": "Κατάσταση"
      }
    },
    "MedicalImages": {
      "title": "Ιατρικές Εικόνες",
      "headers": {
        "onset_date": "Ημερομηνία Έναρξης",
        "hcp_name": "Όνομα Ιατρού",
        "hcp_surname": "Επώνυμο Ιατρού",
        "organization_name": "Όνομα Οργανισμού",
        "preview": "Προεπισκόπηση",
        "status": "Κατάσταση"
      }
    },
    "MedicalReports": {
      "title": "Αναφορά Ιατρικών Εικόνων",
      "headers": {
        "onset_date": "Ημερομηνία Έναρξης",
        "hcp_name": "Όνομα Ιατρού",
        "hcp_surname": "Επώνυμο Ιατρού",
        "organization_name": "Όνομα Οργανισμού",
        "preview": "Προεπισκόπηση",
        "status": "Κατάσταση"
      }
    }
  },
  "date": {
    "labels": {
      "dob": "Ημερομηνία Γεννήσεως",
      "on_set": "Ημερομηνία Έναρξης",
      "start_date": "Ημερομηνία Έναρξης",
      "end_date": "Ημερομηνία Λήξης",
      "start_year": "Έτος Έναρξης",
      "end_year": "Έτος Λήξης",
      "vaccination_date": "Ημερομηνία Εμβολιασμού",
      "surgery_date": "Ημερομηνία Χειρουργικής Διαδικασίας",
      "implant_date": "Ημερομηνία Διαδικασίας Εμφύτευσης",
      "bp_measurement_date": "Ημερομηνία Μέτρησης Αρτηριακής Πίεσης",
      "test_date": "Ημερομηνία",
      "delivery_date": "Ημερομηνία Τοκετού"
    },
    "placeholders": {
      "default": "Πληκτρολογήστε εδώ..."
    }
  },
  "button": {
    "yes": "Ναι",
    "no": "Όχι",
    "ok": "Εντάξει",
    "cancel": "Άκυρο",
    "save": "Αποθήκευση",
    "reset": "Επαναφορά",
    "search": "Αναζήτηση",
    "create_ps": "Δημιουργία Φακέλου Ασθενή",
    "add_drug_allergy": "Προσθήκη Αλλεργίας Σε Φάρμακο",
    "add_non_drug_allergy": "Προσθήκη Μη Φαρμακευτικής Αλλεργίας",
    "add_eprescription": "Προσθήκη Συνταγής",
    "add_orcd": "Επεξεργασία ORCD",
    "back": "Πίσω",
    "close_preview": "Κλείσιμο προεπισκόπησης",
    "tooltips": {
      "edit_ps": "Επεξεργασία φακέλου ασθενή",
      "save_ps": "Αποθήκευση έκδοσης φακέλου ασθενή",
      "discard_ps": "Απόρριψη έκδοσης φακέλου ασθενή",
      "enable_entry": "Ενεργοποίηση αυτής της Καταχώρισης",
      "disable_entry": "Απενεργοποίηση αυτής της Καταχώρισης",
      "delete_entry": "Διαγραφή αυτής της Καταχώρισης",
      "add_contact": "Προσθήκη προσώπου επικοινωνίας",
      "add_insurance": "Προσθήκη πληροφοριών ασφάλισης ασθενή",
      "add_drug_allergy": "Προσθήκη αλλεργίας σε φάρμακο",
      "add_non_drug_allergy": "Προσθήκη μη φαρμακευτικής αλλεργίας",
      "add_vaccination": "Προσθήκη εμβολιασμού",
      "add_illness": "Προσθήκη παρελθοντικής ασθένειας",
      "add_procedure": "Προσθήκη χειρουργικής επέμβασης",
      "add_problem": "Προσθήκη προβλήματος/διάγνωσης",
      "add_device": "Προσθήκη ιατρικής συσκευής/εμφυτεύματος",
      "add_treatment": "Προσθήκη σύστασης θεραπείας",
      "add_autonomy": "Προσθήκη αυτονομίας/αναπηρίας",
      "add_medication": "Προσθήκη φαρμακευτικής αγωγής",
      "add_social_history": "Προσθήκη κοινωνικού ιστορικού",
      "add_physical_finding": "Προσθήκη αρτηριακής πίεσης",
      "add_diagnostic_test": "Προσθήκη διαγνωστικής εξέτασης",
      "add_pregnancy": "Προσθήκη ιστορικού εγκυμοσύνης",
      "add_orcd": "Προσθήκη πρωτότυπων κλινικών εγγράφων",
      "save_orcd": "Αποθήκευση πρωτότυπων κλινικών εγγράφων",
      "add_lab_report": "Προσθήκη αναφοράς εργαστηριακών αποτελεσμάτων",
      "add_hospital_report": "Προσθήκη αναφοράς εξιτηρίων νοσοκομείων",
      "add_medical_report": "Προσθήκη αναφοράς ιατρικών εικόνων",
      "add_medical_image": "Προσθήκη ιατρικών εικόνων",
      "add_eprescription": "Προσθήκη ηλεκτρονικής συνταγής",
      "preview_pdf": "Προεπισκόπηση Εγγράφου PDF",
      "preview_cda": "Προεπισκόπηση Εγγράφου CDA"
    }
  },
  "modal": {
    "titles": {
      "enable_entry": "Ενεργοποίηση Καταχώρισης",
      "disable_entry": "Απενεργοποίηση Καταχώρισης",
      "delete_entry": "Διαγραφή Καταχώρισης",
      "add_contact": "Προσθήκη Προσώπου Επικοινωνίας",
      "add_insurance": "Προσθήκη πληροφοριών ασφάλισης ασθενή",
      "add_drug_allergy": "Προσθήκη αλλεργίας σε φάρμακο",
      "add_non_drug_allergy": "Προσθήκη μη φαρμακευτικής αλλεργίας",
      "add_vaccination": "Προσθήκη Εμβολιασμού",
      "add_illness": "Προσθήκη παρελθοντικής ασθένειας",
      "add_procedure": "Προσθήκη Χειρουργικής Διαδικασίας",
      "add_problem": "Προσθήκη Προβλήματος/Διάγνωσης",
      "add_device": "Προσθήκη Ιατρικής Συσκευής/Εμφυτεύματος",
      "add_treatment": "Προσθήκη Σύστασης Θεραπείας",
      "add_autonomy": "Προσθήκη Αυτονομίας/Αναπηρίας",
      "add_medication": "Προσθήκη Φαρμακευτικής Αγωγής",
      "add_social_history": "Προσθήκη Κοινωνικού Ιστορικού",
      "add_physical_finding": "Προσθήκη Αρτηριακής Πίεσης",
      "add_eprescription": "Προσθήκη Ηλεκτρονικής Συνταγής",
      "edit_ps": "Επεξεργασία Συνοπτικού Ιστορικού Ασθενούς",
      "create_ps": "Δημιουργία Συνοπτικού Ιστορικού Ασθενούς",
      "add_diagnostic_test": "Προσθήκη Διαγνωστικής Εξέτασης",
      "add_pregnancy": "Προσθήκη Ιστορικού Εγκυμοσύνης",
      "add_lab_report": "Προσθήκη Εργαστηριακής Αναφοράς",
      "add_hospital_report": "Προσθήκη Νοσοκομειακής Αναφοράς",
      "add_medical_report": "Προσθήκη Ιατρικής Αναφοράς",
      "add_medical_image": "Προσθήκη Ιατρικής Εικόνας",
      "user_profile": "Προφίλ Χρήστη",
      "preview_document": "Προεπισκόπηση Εγγράφου",
      "edit_phone": "Επεξεργασία Αριθμού Τηλεφώνου",
      "edit_email": "Επεξεργασία Ηλεκτρονικού Ταχυδρομίου",
      "edit_address": "Επεξεργασία Διεύθυνσης",
      "confirm_email": "Επαλήθευση Κωδικού Μίας Χρήσης"
    },
    "messages": {
      "confirm_enable": "Είστε σίγορροι πως θέλετε να ενεργοποιήσετε αυτή τη Καταχώριση;",
      "confirm_disable": "Είστε σίγουροι πως θέλετε να απενεργοποιήσετε αυτή τη Καταχώριση;",
      "confirm_delete": "Είστε σίγουροι πως θέλετε να διαγράψετε αυτή τη Καταχώριση;",
      "consent_ps": "Κατανοώ ότι θα γίνω ο νόμιμος συγγραφέας του συνοπτικού ιστορικού υγείας του ασθενούς {{name}} {{surname}};"
    },
    "validations": {
      "pi_codingIdInvalid": "Το πεδίο \"Περιγραφή Προβλημάτων/Διάγνωσης\" είναι υποχρεωτικό",
      "pi_onSetDateInvalid": "Το πεδίο \"Ημερομηνία Έναρξης\" είναι υποχρεωτικό",
      "pi_endDateInvalid": "Το πεδίο \"Ημερομηνία Λήξης\" είναι υποχρεωτικό",
      "pi_resolutionInvalid": "Το πεδίο \"Συνθήκες Επίλυσης\" είναι υποχρεωτικό",
      "pi_onSetNotAfterEnd": "Η ημερομηνία στο πεδίο \"Ημερομηνία Έναρξης\" πρέπει να είναι πριν την ημερομηνία στο πεδίο \"Ημερομηνία Λήξης\"",
      "pi_startNotAfterPatientDoB": "Η ημερομηνία στο πεδίο \"Ημερομηνία Έναρξης\" πρέπει να είναι μετά την ημερομηνία γεννήσεως του ασθενή",
      "pi_endDateNotBeforeToday": "Η ημερομηνία στο πεδίο \"Ημερομηνία Λήξης\" πρέπει να είναι πριν την σημερινή ημερομηνία",
      "m_codingIdInvalid": "Το πεδίο \"Αναζήτηση Φαρμακευτικού Προϊόντος\" είναι υποχρεωτικό",
      "m_packageIdInvalid": "Το πεδίο \"Περιγραφή Συσκευασίας\" είναι υποχρεωτικό",
      "m_noPackagesInvalid": "Το πεδίο \"Αριθμός Συσκευασιών\" είναι υποχρεωτικό",
      "m_unitsIntakeInvalid": "Το πεδίο \"Μονάδες ανά Δόση\" είναι υποχρεωτικό εαν το πεδίο \"Ποσότητα\" περιέχει μια έγκυρη τιμή",
      "m_frequencyUnitsInvalid": "Το πεδίο \"Μονάδες Χρόνου\" είναι υποχρεωτικό εαν το πεδίο \"Συχνότητα λήψης\" περιέχει μια έγκυρη τιμή",
      "m_durationUnitsInvalid": "Το πεδίο \"Μονάδες Χρόνου\" είναι υποχρεωτικό εαν το πεδίο \"Διάρκεια θεραπείας\" περιέχει μια έγκυρη τιμή",
      "m_quantityInvalid": "Το πεδίο \"Ποσότητα\" είναι υποχρεωτικό",
      "m_frequencyInvalid": "Το πεδίο \"Συχνότητα Λήψης\" είναι υποχρεωτικό",
      "m_durationInvalid": "Το πεδίο \"Διάρκεια Θεραπείας\" είναι υποχρεωτικό",
      "m_onSetDateInvalid": "Το πεδίο \"Ημερομηνία Έναρξης\" είναι υποχρεωτικό",
      "m_onSetDateAfterDOB": "Η ημερομηνία στο πεδίο \"Ημερομηνία Έναρξης\" πρέπει να είναι μετά την ημερομηνία γεννήσεως του ασθενή",
      "m_onSetDateBeforeToday": "Η ημερομηνία στο πεδίο \"Ημερομηνία Έναρξης\" πρέπει να είναι πριν την σημερινή ημερομηνία",
      "m_onSetDateAfterToday": "Η ημερομηνία στο πεδίο \"Ημερομηνία Έναρξης\" πρέπει να είναι μετά την σημερινή ημερομηνία",
      "m_substitutionInvalid": "Το πεδίο \"Επιτρέπεται Υποκατάσταση Εμπορικής Ονομασίας\" είναι υποχρεωτικό",
      "cp_givenNameInvalid": "Το πεδίο \"Όνομα'\" είναι υποχρεωτικό",
      "cp_familyNameSurnameInvalid": "Το πεδίο \"Επώνυμο\" είναι υποχρεωτικό",
      "cp_telephoneNoInvalid": "Το πεδίο \"Διεύθυνση\" είναι υποχρεωτικό",
      "cp_countryIdInvalid": "Το πεδίο \"Χώρα\" είναι υποχρεωτικό",
      "cp_addressInvalid": "Το πεδίο \"Τηλέφωνο\" είναι υποχρεωτικό",
      "cp_emailInvalid": "Το πεδίο \"Ηλεκτρονικό Ταχυδρομίο\" είναι υποχρεωτικό",
      "i_nameInvalid": "Το πεδίο \"Ασφαλιστική Επωνυμία\" είναι υποχρεωτικό",
      "i_numberInvalid": "Το πεδίο \"Αριθμός Ασφάλειας\" είναι υποχρεωτικό",
      "da_allergyCodingIdInvalid": "Το πεδίο \"Περιγραφή Αλλεργίας\" είναι υποχρεωτικό",
      "da_agentCodingIdInvalid": "Το πεδίο \"Περιγραφή Αντιπροσώπου\" είναι υποχρεωτικό",
      "nda_allergenCodingIdInvalid": "Το πεδίο \"Περιγραφή Αλλεργιογόνου\" είναι υποχρεωτικό",
      "da_onSetDateInvalid": "Το πεδίο \"Ημερομηνία Έναρξης\" είναι υποχρεωτικό",
      "da_onSetDateAfterDOB": "Η ημερομηνία στο πεδίο \"Ημερομηνία Έναρξης\" πρέπει να είναι μετά την ημερομηνία γεννήσεως του ασθενή",
      "da_onSetDateBeforeToday": "Η ημερομηνία στο πεδίο \"Ημερομηνία Έναρξης\" πρέπει να είναι πριν την σημερινή ημερομηνία",
      "v_vaccinationIdInvalid": "Το πεδίο \"Αναζήτηση Εμβολίου\" είναι υποχρεωτικό",
      "v_vaccinationDateInvalid": "Το πεδίο \"Ημερομηνία Εμβολιασμού\" είναι υποχρεωτικό",
      "v_vaccinationDateAfterDOB": "Η ημερομηνία στο πεδίο \"Ημερομηνία Εμβολιασμού\" πρέπει να είναι μετά την ημερομηνία γεννήσεως του ασθενή",
      "v_vaccinationDateBeforeToday": "Η ημερομηνία στο πεδίο \"Ημερομηνία Εμβολιασμού\" πρέπει να είναι πριν την σημερινή ημερομηνία",
      "sp_codingIdInvalid": "Το πεδίο \"Περιγραφή Χειρουργικής Επέμβασης\" είναι υποχρεωτικό",
      "sp_procedureDateInvalid": "Το πεδίο \"Ημερομηνία Έναρξης\" είναι υποχρεωτικό",
      "sp_procedureDateAfterDOB": "Η ημερομηνία στο πεδίο \"Ημερομηνία Έναρξης\" πρέπει να είναι μετά την ημερομηνία γεννήσεως του ασθενή",
      "sp_procedureDateBeforeToday": "Η ημερομηνία στο πεδίο \"Ημερομηνία Έναρξης\" πρέπει να είναι πριν την σημερινή ημερομηνία",
      "pd_codingIdInvalid": "Το πεδίο \"Περιγραφή Προβλήματος/Διάγνωσης\" είναι υποχρεωτικό",
      "pd_problemDateInvalid": "Το πεδίο \"Ημερομηνία Έναρξης\" είναι υποχρεωτικό",
      "pd_problemDateAfterDOB": "Η ημερομηνία στο πεδίο \"Ημερομηνία Έναρξης\" πρέπει να είναι μετά την ημερομηνία γεννήσεως του ασθενή",
      "pd_problemDateBeforeToday": "Η ημερομηνία στο πεδίο \"Ημερομηνία Έναρξης\" πρέπει να είναι πριν την σημερινή ημερομηνία",
      "di_deviceCodingIdInvalid": "Το πεδίο \"Περιγραφή Συσκευής/Εμφυτεύματος\" είναι υποχρεωτικό",
      "di_implantDateInvalid": "Το πεδίο \"Ημερομηνία Εμφύτευσης\" είναι υποχρεωτικό",
      "di_implantDateAfterDOB": "Η ημερομηνία στο πεδίο \"Ημερομηνία Εμφύτευσης\" πρέπει να είναι μετά την ημερομηνία γεννήσεως του ασθενή",
      "di_implantDateBeforeToday": "Η ημερομηνία στο πεδίο \"Ημερομηνία Εμφύτευσης\" πρέπει να είναι πριν την σημερινή ημερομηνία",
      "tr_descriptionInvalid": "Το πεδίο \"Σύσταση Θεραπείας\" είναι υποχρεωτικό",
      "ai_descriptionInvalid": "Το πεδίο \"Περιγραφή\" είναι υποχρεωτικό",
      "sh_codingIdInvalid": "Το πεδίο \"Περιγραφή Κοινωνικού Ιστορικού\" είναι υποχρεωτικό",
      "sh_startDateInvalid": "Το πεδίο \"Ημερομηνία Έναρξης\" είναι υποχρεωτικό",
      "sh_endDateInvalid": "Η ημερομηνία στο πεδίο \"Ημερομηνία Λήξης\" είναι λανθασμένη",
      "sh_onSetNotAfterEnd": "Η ημερομηνία στο πεδίο \"Ημερομηνία Έναρξης\" πρέπει να είναι πριν την ημερομηνία στο πεδίο \"Ημερομηνία Λήξης\"",
      "sh_startNotAfterPatientDoB": "Η ημερομηνία στο πεδίο \"Ημερομηνία Έναρξης\" πρέπει να είναι μετά την ημερομηνία γεννήσεως του ασθενή",
      "sh_endDateNotBeforeToday": "Η ημερομηνία στο πεδίο \"Ημερομηνία Λήξης\" πρέπει να είναι πριν την σημερινή ημερομηνία",
      "pf_systolicInvalid": "Το πεδίο \"Συστολική Αρτηριακή Πίεση\" είναι υποχρεωτικό",
      "pf_diastolicInvalid": "Το πεδίο \"Διαστολική Αρτηριακή Πίεση\" είναι υποχρεωτικό",
      "pf_systolicLessThanDiastolic": "Η τιμή στο πεδίο \"Συστολική Αρτηριακή Πίεση\" πρέπει να είναι μεγαλύτερη από την τιμή στο πεδίο \"Διαστολική Αρτηριακή Πίεση\"",
      "pf_measurementDateInvalid": "Το πεδίο \"Ημερομηνία Μέτρησης Αρτηριακής Πίεσης\" είναι υποχρεωτικό",
      "pf_measurementDateAfterDOB": "Η ημερομηνία στο πεδίο \"Ημερομηνία Μέτρησης Αρτηριακής Πίεσης\" πρέπει να είναι μετά την ημερομηνία γεννήσεως του ασθενή",
      "pf_measurementDateBeforeToday": "Η ημερομηνία στο πεδίο \"Ημερομηνία Μέτρησης Αρτηριακής Πίεσης\" πρέπει να είναι πριν την σημερινή ημερομηνία",
      "dt_codingIdInvalid": "Το πεδίο \"Ομάδα Αίματος\" είναι υποχρεωτικό",
      "dt_dateInvalid": "Το πεδίο \"Ημερομηνία\" είναι υποχρεωτικό",
      "dt_dateAfterDOB": "Η ημερομηνία στο πεδίο \"Ημερομηνία\" πρέπει να είναι μετά την ημερομηνία γεννήσεως του ασθενή",
      "dt_dateBeforeToday": "Η ημερομηνία στο πεδίο \"Ημερομηνία\" πρέπει να είναι πριν την σημερινή ημερομηνία",
      "ph_codingIdInvalid": "Το πεδίο \"Περιγραφή Εγκυμοσύνης\" είναι υποχρεωτικό",
      "ph_deliveryDateInvalid": "Το πεδίο \"Ημερομηνία Τοκετού\" είναι υποχρεωτικό",
      "orcd_hospitalInvalid": "Το πεδίο \"Νοσοκομείο\" είναι υποχρεωτικό",
      "orcd_authorInvalid": "Το πεδίο \"Ονοματεπώνυμο Συντάκτη\" είναι υποχρεωτικό",
      "orcd_specialtyInvalid": "Το πεδίο \"Ειδικότητα\" είναι υποχρεωτικό",
      "orcd_hospitalizationInvalid": "Το πεδίο \"Λόγος Νοσηλείας\" είναι υποχρεωτικό",
      "orcd_onSetDateInvalid": "Το πεδίο \"Ημερομηνία Έναρξης\" είναι υποχρεωτικό",
      "οrcd_onSetDateAfterDOB": "Η ημερομηνία στο πεδίο \"Ημερομηνία Έναρξης\" πρέπει να είναι μετά την ημερομηνία γεννήσεως του ασθενή",
      "orcd_onSetDateBeforeToday": "Η ημερομηνία στο πεδίο \"Ημερομηνία Έναρξης\" πρέπει να είναι πριν την σημερινή ημερομηνία",
      "orcd_hfileInvalid": "Το πεδίο \"Επιλέφτε Αρχείο (PDF)\" είναι υποχρεωτικό",
      "orcd_labInvalid": "Το πεδίο \"Εργαστήριο\" είναι υποχρεωτικό",
      "orcd_medicalCenterInvalid": "Το πεδίο \"Ιατρικό Κέντρο\" είναι υποχρεωτικό",
      "dem_emailInvalid": "Το πεδίο \"Νέο Ηλεκτρονικό Ταχυδρομίο\" είναι υποχρεωτικό",
      "dem_emailNewSameOldInvalid": "Η τιμή στο πεδίο \"Νέο Ηλεκτρονικό Ταχυδρομίο\" δεν πρέπει να είναι η ίδια με την τιμή στο πεδίο \"Τρέχων Ηλεκτρονικό Ταχυδρομίο\"",
      "dem_emailPatternInvalid": "Το πεδίο \"Νέο Ηλεκτρονικό Ταχυδρομίο\" δεν είναι έγκυρο",
      "dem_otpInvalid": "Το πεδίο \"Κωδικός μιας Χρήσης\" είναι υποχρεωτικό",
      "dem_phoneInvalid": "Το πεδίο \"Νέος Αριθμός Κινητού Τηλεφώνου\" είναι υποχρεωτικό",
      "dem_phoneNewSameOldInvalid": "Η τιμή στο πεδίο \"Νέος Αριθμός Κινητού Τηλεφώνου\" δεν πρέπει να είναι η ίδια με την τιμή στο πεδίο \"Τρέχων Αριθμός Κινητού Τηλεφώνου\"",
      "dem_addressInvalid": "Το πεδίο \"Διεύθυνση\" είναι υποχρεωτικό",
      "dem_addressNumberInvalid": "Το πεδίο \"Αριθμός\" είναι υποχρεωτικό",
      "dem_postalCodeInvalid": "Το πεδίο \"Ταχυδρομικός Κώδικας\" είναι υποχρεωτικό",
      "dem_cityInvalid": "Το πεδίο \"Πόλη\" είναι υποχρεωτικό"
    }
  },
  "alert": {
    "titles": {
      "error": "Σφάλμα:",
      "patient_record_version": "Έκδοση Συνοπτικού Ιστορικού Υγείας Ασθενή:"
    },
    "patient_locked": "Ο ασθενής είναι κλειδωμένος σε άλλο γιατρό.",
    "patient_not_found": "Ο ασθενής δεν βρέθηκε.",
    "patient_error": "Κατά τη διάρκεια έυρεσης του ασθενή.",
    "otp_error": "Κατά την εισαγωγή του κωδικού μιας χρήσης.",
    "demographics_error": "Κατά την εισαγωγή των δημογραφικών στοιχείων του ασθενή.",
    "patient_version_info": "Ημερομηνία: {1} (Πιο πρόσφατο) | Ιατρός: {2}",
    "draft": "Προσχέδιο"
  },
  "cy": {
    "idTypes": {},
    "idFormats": {
      "arc": "05xxxxxxxx",
      "cypriot": "xxxxxxxxxx"
    },
    "validations": {
      "sfrm_patientIdInvalid": "Το πεδίο \"Αριθμός Εγγράφου\" είναι υποχρεωτικό",
      "sfrm_patientIdCICPatternInvalid": "Το πεδίο \"Αριθμός Εγγράφου\" πρέπει να έχει την μορφή XXXXXXXXXX",
      "sfrm_patientIdARCPatternInvalid": "Το πεδίο \"Αριθμός Εγγράφου\" πρέπει να έχει την μορφή \"05-0-XXXXXXX\" αποτελούμενος απο 10 ψηφία.",
      "sfrm_dobDateInvalid": "Το πεδίο \"Ημερομηνία Γεννήσεως\" είναι υποχρεωτικό",
      "sfrm_dobBeforeToday": "Η ημερομηνία στο πεδίο \"Ημερομηνία Γεννήσεως\" πρέπει να είναι πριν την σημερινή ημερομηνία",
      "dfrm_addressInvalid": "Το πεδίο \"Διεύθυνση\" είναι υποχρεωτικό",
      "dfrm_addressNumberInvalid": "Το πεδίο \"Αριθμός\" είναι υποχρεωτικό",
      "dfrm_postalCodeInvalid": "Το πεδίο \"Ταχυδρομικός Κώδικας\" είναι υποχρεωτικό",
      "dfrm_cityInvalid": "Το πεδίο \"Πόλη\" είναι υποχρεωτικό",
      "dfrm_emailPatternInvalid": "Το πεδίο \"Ηλεκτρονικό Ταχυδρομείο\" δεν είναι έγκυρο",
      "dfrm_telephoneInvalid": "Το πεδίο \"Αριθμός Κινητού Τηλεφώνου\" είναι υποχρεωτικό",
      "ofrm_otpInvalid": "Το πεδίο \"Κωδικός μιας Χρήσης\" είναι υποχρεωτικό"
    },
    "otp_expires": "Ο κωδικός μιας χρήσης λήγει σε {1}.",
    "otp_expired": "Ο κωδικός μιας χρήσης έχει λήξει.",
    "resend_otp": "Επαναποστολή Κωδικού μιας Χρήσης;",
    "minutes": "λεπτά",
    "minute": "λεπτό",
    "seconds": "δευτερόλεπτα",
    "second": "δευτερόλεπτο",
    "and": "και"
  },
  "eu": {
    "select_country": "Επιλέξτε Χώρα",
    "scan_qr": "Σάρωση από το Ευρωπαϊκό Ψηφιακό Πορτοφόλι",
    "patient_retrieve": "Φόρμα Ανάκτησης Δεδομένων Ασθενούς",
    "regional_id": "Περιφερειακή ταυτοποίηση",
    "regional_search": "Αναζήτηση με χρήση των περιφερειακών αναγνωριστικών του ασθενούς.",
    "or": "Ή",
    "national_id": "Εθνική ταυτοποίηση",
    "national_search": "Αναζήτηση με χρήση του εθνικού αναγνωριστικού του ασθενούς.",
    "search": "Αναζήτηση",
    "prescription_id": "Αναγνωριστικό Συνταγής",
    "pin_code": "Κωδικός PIN",
    "retrieve": "Ανάκτηση",
    "print": "Εκτύπωση",
    "dispense": "Εκτέλεση συνταγής",
    "display": "Προβολή",
    "prescription_error": "Δεν βρέθηκαν έγγραφα ηλεκτρονικής συνταγογράφησης.",
    "document_list": "Λίστα εγγράφων ασθενούς",
    "ps_error": "Δεν βρέθηκαν έγγραφα συνοπτικού ιστορικού ασθενούς."
  },
  "patient": {
    "nodata": "Δεν έχει βρεθεί ή δημιουργηθεί συνοπτικό ιστορικό υγείας, παρακαλώ όπως επικοινωνήσετε με τον προσωπικό σας γιατρό για να το δημιουργήσει.",
    "demographics": {
      "id": "Αρ. Ταυτότητας",
      "name": "Όνομα",
      "surname": "Επίθετο",
      "date_of_birth": "Ημερομηνία Γεννήσεως",
      "gender": "Φύλο",
      "telephone": "Τηλέφωνο",
      "country": "Χώρα"
    },
    "menu": {
      "ps": "Συνοπτικό Ιστορικό Υγείας",
      "ep": "Ηλεκτρονική Συνταγή",
      "orcd": "Πρωτότυπα Κλινικά Έγγραφα",
      "vac": "Ευρωπαϊκή Κάρτα Εμβολιασμών",
      "ps_text": "Περιλαμβάνει απαραίτητες πληροφορίες ώστε να εξασφαλίζεται η ορθή, ασφαλής και έγκαιρη αντιμετώπιση του ασθενούς.",
      "ep_text": "Επιτρέπει σε έναν ασθενή να λάβει συνταγή για φάρμακο από ιατρό στη χώρα μόνιμης διαμονής του και να εκτελέσει τη συνταγή σε φαρμακείο άλλης χώρα της ΕΕ.",
      "orcd_text": "Έγγραφα που περιέχουν πληροφορίες για την υγεία σας όπως αναφορά εργαστηριακών αποτελεσμάτων, αναφορά εξιτηρίων νοσοκομείων και αναφορά ιατρικών εικόνων.",
      "vac_text": "Ευρωπαϊκή Κάρτα Εμβολιασμών επεξηγηματικό σχόλιο",
      "enter": "Είσοδος"
    },
    "summary": {
      "patient_data": "Δεδομένα Ασθενή",
      "demographics": "Πληροφορίες Δημογραφικών Στοιχείων Ασθενούς",
      "contacts": "Πρόσωπα Επικοινωνίας",
      "insurances": "Πληροφορίες Ασφαλίσεων Ασθενούς",
      "clinical_data": "Κλινικά Δεδομένα Ασθενή",
      "allergies": "Αλλεργίες",
      "vaccinations": "Εμβολιασμοί",
      "past_illness": "Ιστορικό Παρελθοντικών Ασθενειών",
      "surgical_procedures": "Χειρουργικές Επεμβάσεις",
      "problems_diagnoses": "Τρέχοντα Προβλήματα/Διαγνώσεις",
      "devices_implants": "Ιατρικές Συσκευές και Εμφυτεύματα",
      "treatments": "Συστήνουσα θεραπεία",
      "autonomy_invalidity": "Αυτονομία/Αναπηρία",
      "medication": "Συνοπτικό Φαρμακευτικό Ιστορικό",
      "social_history": "Κοινωνικό Ιστορικό",
      "physical_findings": "Φυσικά Ευρήματα",
      "diagnostic_tests": "Διαγνωστικές Εξετάσεις",
      "pregnancies": "Ιστορικό Εγκυμοσύνης",
      "versioning_data": "Δεδομένα Συνοπτικού Ιστορικού Υγείας Ασθενή",
      "versions": "Εκδόσεις"
    },
    "ps": {
      "medication": {
        "atc_code": "Κωδικός ATC",
        "active_substance": "Δραστική(-ές) Ουσία(-ες)",
        "product_name": "Επωνυμία Προϊόντος",
        "strength": "Δύναμη",
        "dose_form": "Μορφή Δοσολογίας Φαρμάκου",
        "description": "Περιγραφή",
        "dosage": "Δοσολογία",
        "packaging": "Συσκευασία",
        "not_applicable": "Δεν Ισχύει",
        "every": "κάθε",
        "hour": "Ώρα(ες)",
        "day": "Μέρα(ες)",
        "week": "Εβδομάδα(ες)",
        "month": "Μήνα(ες)",
        "year": "Χρόνος(ια)",
        "administration_route": "Τρόπος Χορήγησης",
        "substitutionAllowed": "Επιτρέπεται Υποκατάσταση Εμπορικής Ονομασίας",
        "substitution": "Υποκατάστατο Εμπορικής Ονομασίας",
        "dispensation_form": "Φόρμα Εκτέλεσης",
        "dispense": "Εκτέλεση",
        "ep_list": "Λίστα Ηλεκτρονικών Συνταγών Ασθενούς"
      },
      "vaccinations": {
        "vaccinations": "Εμβολιασμοί",
        "description": "Περιγραφή",
        "brand_name": "Εμπορική Ονομασία"
      }
    },
    "orcd": {
      "title": "Πρωτογενή Κλινικά Έγγραφα",
      "hospital_reports": "Νοσοκομειακές Εκθέσεις",
      "lab_reports": "Εργαστηριακά Αποτελέσματα",
      "medical_images": "Ιατρικές Εικόνες",
      "medical_reports": "Ιατρικές Εκθέσεις"
    }
  },
  "switch": {
    "brandName": "Αναζήτηση με εμπορική ονομασία",
    "code": "Αναζήτηση με κωδικό",
    "description": "Αναζήτηση με περιγραφή"
  },
  "radios": {
    "brand_name": "Εμπορική Ονομασία",
    "active_substance": "Ενεργό Συστατικό",
    "atc_code": "Κωδικός ATC",
    "yes": "Ναι",
    "no": "Όχι"
  },
  "breadcrumb": {
    "home": "Αρχική",
    "cy": "Εθνικός Πολίτης",
    "eu": "Ευρωπαίος Πολίτης",
    "patient": "Μενού Ασθενή",
    "ps": "Φάκελος Ασθενή",
    "edit": "Επεξεργασία",
    "create": "Δημιουργία",
    "ep": "Ηλεκτρονικές Συνταγές",
    "orcd": "Πρωτότυπα Κλινικά Έγγραφα",
    "at": "Αυστρία",
    "be": "Βέλγιο",
    "bg": "Βουλγαρία",
    "cz": "Τσεχία",
    "de": "Γερμανία",
    "dk": "Δανία",
    "ee": "Εσθονία",
    "es": "Ισπανία",
    "fi": "Φινλανδία",
    "fr": "Γαλλία",
    "gr": "Ελλάδα",
    "hr": "Κροατία",
    "hu": "Ουγγαρία",
    "ie": "Ιρλανδία",
    "is": "Ισλανδία",
    "it": "Ιταλία",
    "lt": "Λιθουανία",
    "lu": "Λουξεμβούργο",
    "lv": "Λετονία",
    "mt": "Μάλτα",
    "nl": "Ολλανδία",
    "pl": "Πολωνία",
    "pt": "Πορτογαλία",
    "ro": "Ρουμανία",
    "rs": "Σερβία",
    "se": "Σουηδία",
    "si": "Σλοβενία",
    "sk": "Σλοβακία",
    "sw": "Ελβετία",
    "uk": "Ηνωμένο Βασίλειο"
  }
}
